"use strict";

const React = window.React;
const ReactDOM = window.ReactDOM;
import VimeoCard from '../react/VimeoCard.jsx';

document.addEventListener('bb-lumeris:lum-vimeo-card-with-modal:init', (event) => {
    setTimeout(() => { new VimeoCardWithModal(event.detail); }, 1000);
});

class VimeoCardWithModal {
    #data;
  
    module;
    app;

    constructor(data) {
        this.#data = data;
  
        if (!data) {
            return;
        }
  
        this.module = document.querySelector(`[data-node="${data.node}"]`);
        this.app = document.getElementById(`app-${data.node}`);
        this.app._reactRoot = this.app._reactRoot ?? ReactDOM.createRoot(this.app);

        this.app._reactRoot.render(React.createElement(VimeoCard, {
            moduleElement: this.module,
            data: this.#data
        }));
    }

    get data() {
        return this.#data;
    }

}